import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../lib/appRoutes";
import { getShell } from "../lib/apiKey";

export default function Footer() {
  // Apple native shells suppress the shop link — see Table.tsx for the
  // 3.1.1 rejection context. The shop sells physical goods (allowed
  // under 3.1.3(e)) but reviewers conflate the WebView entry with
  // digital content, so we just remove the link entirely from
  // atomizer-ar / atomizer-mac / atomizer-vision /
  // electronvisualized-mac. Customers can still buy from desktop.
  const inAppleShell = ["atomizer-ar", "atomizer-mac", "atomizer-vision", "electronvisualized-mac"].includes(getShell() || "");
  return (
    <footer className="border-t border-white/5 bg-zinc-950 px-4 py-6 text-center text-xs text-zinc-500">
      <p>
        ElectronVisualized — Designed and developed by John Seong
      </p>
      <nav className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px]">
        {!inAppleShell && <Link to={ROUTES.shop} className="hover:text-zinc-300">Shop</Link>}
        <Link to={ROUTES.privacy} className="hover:text-zinc-300">Privacy</Link>
        <Link to={ROUTES.cookies} className="hover:text-zinc-300">Cookies</Link>
        <Link to={ROUTES.license} className="hover:text-zinc-300">License</Link>
        {/* Apple App Review guideline 3.1.2(c) requires the EULA be
            reachable from inside the app. Apple's standard EULA covers
            it without us maintaining custom terms copy. */}
        <a
          href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-zinc-300"
        >
          EULA
        </a>
        <Link to="/support" className="hover:text-zinc-300">Support</Link>
      </nav>
    </footer>
  );
}
